import { ArdoqNodeStyleClone } from 'viewpointBuilder/components/SimpleGraph/ArdoqNodeStyleClone';
import { MetaModelViewGraphNode } from '@ardoq/graph';
import { ComponentRepresentationData } from '@ardoq/basic-components';

const styles = new Map<string, ArdoqNodeStyleClone>();

export const getStyle = (node: MetaModelViewGraphNode) => {
  const typeId = node.getTypeId();

  let nodeStyle = styles.get(typeId);
  if (!nodeStyle) {
    const representationData =
      node.getRepresentationData() as ComponentRepresentationData;
    const color = node.getColor();

    nodeStyle = new ArdoqNodeStyleClone({
      representationData,
      color,
    });
    styles.set(typeId, nodeStyle);
  }
  return nodeStyle;
};
